
import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { tokens } from "../../theme";
import { useTheme } from "@mui/material";

const MetricsCard = ({ metrics }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {metrics.map((metric, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card 
            sx={{ 
              height: "120px",
              display: "flex",
              alignItems: "center",
              background: "linear-gradient(135deg, rgba(18, 86, 103, 0.05) 0%, rgba(0, 178, 207, 0.05) 100%)"
            }}
          >
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%" }}>
              <Box sx={{ color: metric.color }}>
                {metric.icon}
              </Box>
              <Box>
                <Typography variant="h3" sx={{ color: 'var(--fx-text-primary)', fontWeight: 700 }}>
                  {metric.value}
                </Typography>
                <Typography variant="body2" sx={{ color: colors.grey[600] }}>
                  {metric.title}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default MetricsCard;
